import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mb-0" }, "Rimborsa richiesta", -1)
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "status" }, "Stato *", -1)
const _hoisted_4 = { class: "p-field p-mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "admin_notes" }, "Note amministrative", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_PDialog = _resolveComponent("PDialog")!

  return (_openBlock(), _createBlock(_component_PDialog, {
    visible: _ctx.showModel,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModel = $event)),
    style: { width: '450px' },
    modal: true,
    class: "p-fluid",
    draggable: true,
    keepInViewPort: true,
    minX: 0,
    minY: 0,
    onShow: _ctx.onShow,
    onHide: _ctx.onHide
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Annulla",
        icon: "pi pi-times",
        class: "p-button-secondary",
        onClick: _ctx.onCancel
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Conferma",
        icon: "pi pi-check",
        loading: _ctx.isLoading,
        onClick: _ctx.onSubmit
      }, null, 8, ["loading", "onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Dropdown, {
            id: "status",
            modelValue: _ctx.formData.status,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.formData.status = $event)),
            options: _ctx.statusOptions,
            optionLabel: "label",
            optionValue: "value",
            placeholder: "Seleziona stato",
            required: ""
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_Textarea, {
            id: "admin_notes",
            modelValue: _ctx.formData.admin_notes,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.admin_notes = $event)),
            rows: 5,
            placeholder: "Inserisci note..."
          }, null, 8, ["modelValue"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["visible", "onShow", "onHide"]))
}